/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_FinishedInputs */

const th_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จบการแข่งขัน`)
};

const en_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finished`)
};

const ja_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

const zh_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已结束`)
};

const es_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

const pt_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrado`)
};

const id_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai`)
};

const fr_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const tl_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapos na`)
};

const vi_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết thúc`)
};

const ko_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종료`)
};

const de_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet`)
};

const ru_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершён`)
};

const tr_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitti`)
};

const it_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclusa`)
};

const pl_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakończony`)
};

const uk_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершено`)
};

const hi_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्त`)
};

const ar_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهت`)
};

const ms_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai`)
};

const bn_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শেষ`)
};

const zh_tw2_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

const zh_hk2_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已結束`)
};

const ur_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ختم`)
};

const fa_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پایان‌یافته`)
};

const sw_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umeisha`)
};

const nl_status_finished = /** @type {(inputs: Status_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgelopen`)
};

/**
* | output |
* | --- |
* | "Finished" |
*
* @param {Status_FinishedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const status_finished = /** @type {((inputs?: Status_FinishedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_FinishedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_status_finished(inputs)
	if (locale === "ja") return ja_status_finished(inputs)
	if (locale === "zh") return zh_status_finished(inputs)
	if (locale === "es") return es_status_finished(inputs)
	if (locale === "pt") return pt_status_finished(inputs)
	if (locale === "id") return id_status_finished(inputs)
	if (locale === "fr") return fr_status_finished(inputs)
	if (locale === "tl") return tl_status_finished(inputs)
	if (locale === "vi") return vi_status_finished(inputs)
	if (locale === "ko") return ko_status_finished(inputs)
	if (locale === "de") return de_status_finished(inputs)
	if (locale === "ru") return ru_status_finished(inputs)
	if (locale === "tr") return tr_status_finished(inputs)
	if (locale === "it") return it_status_finished(inputs)
	if (locale === "pl") return pl_status_finished(inputs)
	if (locale === "uk") return uk_status_finished(inputs)
	if (locale === "hi") return hi_status_finished(inputs)
	if (locale === "ar") return ar_status_finished(inputs)
	if (locale === "ms") return ms_status_finished(inputs)
	if (locale === "bn") return bn_status_finished(inputs)
	if (locale === "zh-TW") return zh_tw2_status_finished(inputs)
	if (locale === "zh-HK") return zh_hk2_status_finished(inputs)
	if (locale === "ur") return ur_status_finished(inputs)
	if (locale === "fa") return fa_status_finished(inputs)
	if (locale === "sw") return sw_status_finished(inputs)
	if (locale === "nl") return nl_status_finished(inputs)
	return en_status_finished(inputs)
});